import React, { useEffect, useState } from "react";
import { Form, Button, Typography, Flex, Grid } from "antd";
import { App } from "antd";
import InputField from "../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createOrUpdateGroup } from "../groupThunks";
import { setSelectedGroup, setIsEditGroup } from "../groupSlice";
import { getAccessType } from "../../../lib/functions";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateGroupForm = () => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = useForm();
  const screens = useBreakpoint();

  const { isEditGroup, selectedGroup } = useSelector((state) => state.groups);
  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("group_entry");
    access_type_set(access);
  }, []);

  useEffect(() => {
    if (isEditGroup && selectedGroup) {
      form.setFieldsValue(selectedGroup);
    } else {
      form.resetFields();
    }
  }, [isEditGroup, selectedGroup]);

  const handleCancel = () => {
    dispatch(setSelectedGroup(null));
    dispatch(setIsEditGroup(false));
    navigate(-1);
  };

  const handleSave = async (values) => {
    try {
      await dispatch(
        createOrUpdateGroup({
          ...values,
          action: isEditGroup ? "update" : "create",
          group_id: selectedGroup?.group_id || 0,
        })
      ).unwrap();

      modal.success({
        title: isEditGroup
          ? "Group updated successfully"
          : "Group created successfully",
      });

      dispatch(setSelectedGroup(null));
      dispatch(setIsEditGroup(false));
      navigate("/inventory/item-group-entry");
    } catch (error) {
      modal.warning({
        title: error.message || "Save failed",
      });
    }
  };

  return (
    <div className="group-form">
      <Title level={2} style={{ marginBottom: "32px" }}>
        {isEditGroup ? "Update Group" : "Create New Group"}
      </Title>

      <Form
        form={form}
        layout="horizontal"
        onFinish={handleSave}
        variant="filled"
        style={{ maxWidth: "1400px" }}
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Group Name"
              name="group_name"
              rules={[{ required: true }]}
            >
              <InputField placeholder="Enter Group Name" />
            </Form.Item>
          </Flex>
        </Flex>

        <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
          <Button
            size="large"
            shape="default"
            onClick={handleCancel}
            className="traic-button"
          >
            Back
          </Button>
          {access_type == "WRITE" && <>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              className="traic-button"
            >
              {isEditGroup ? "Update" : "Save"}
            </Button>
          </>}
        </Flex>
      </Form>
    </div>
  );
};

export default CreateGroupForm;
